<div class="p-4 w-full flex justify-center">
  <svg
    id="svg-tilt-viewer"
    [attr.width]="svgWidth"
    [attr.height]="svgHeight"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
      /* 背景画像を設定する */
      svg {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    </style>
    <g *ngFor="let sensor of drawingTiltSensors">
      <!-- 山留センサーマーカー（円形） - 状態により色変化 -->
      <circle
        [attr.cx]="sensor.x"
        [attr.cy]="sensor.y"
        [attr.r]="markerRadius"
        [attr.fill]="sensor.bgColor || '#ff5722'"
        stroke="white"
        stroke-width="2"
        [class.hide]="!isImageLoaded"
        [class.show]="isImageLoaded"
      ></circle>
      <!-- センサー名表示 -->
      <text
        [attr.x]="sensor.x"
        [attr.y]="sensor.y"
        text-anchor="middle"
        dominant-baseline="central"
        [attr.fill]="sensor.fgColor || 'white'"
        font-size="12"
        font-weight="bold"
        [class.hide]="!isImageLoaded"
        [class.show]="isImageLoaded"
      >
        {{ sensor.positionName }}
      </text>
    </g>
  </svg>
</div>
